import { Feedback } from '@cp/src/pages/CaseDetails/interfaces/Overview.type';
import { ECallingType, FEEDBACK_FORM_STATES } from '../../../interfaces/index.type';

export const WA_MESSAGING_TYPES = {
  HIDE_TAB: 'hideWhatsappTab',
  GET_LOGIN_STATUS: 'getWhatsappLoginStatus',
  LOGIN_STATUS: 'whatsappLoginStatus',
  START_CALL: 'startWhatsappCall',
  DISCONNECT_CALL: 'disconnectWhatsappCall',
  ON_INITIATED: 'onWhatsappCallInitiated',
  ON_ACCEPTED: 'onWhatsappCallAccepted',
  ON_DISCONNECTED: 'onWhatsappCallDisconnected',
  ON_ERROR: 'onError',
  ON_NUMBER_NOT_FOUND: 'onWhatsappNumberNotFound',
  ON_RATING_OVERLAY: 'onWhatsappRatingOverlay',
  DISMISS_OVERLAY: 'dismissWhatsappOverlay',
  FOCUS_WHATSAPP_TAB: 'focusWhatsappTab',
  ENABLE_WHATSAPP_CALLING: 'enableWhatsappCalling'
};

export const WA_STORAGE_KEY = 'WA_CALL_STATE';
export const WA_BROADCAST_CHANNEL = 'wa_call_commands';

export enum WACallStates {
  IDLE = 'idle',
  CHECKING_LOGIN = 'checking_login',
  NEEDS_TAB_SHARE = 'needs_tab_share',
  SETTING_UP = 'setting_up',
  IN_PROGRESS = 'in_progress',
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  UPLOADING = 'uploading',
  AWAITING_FEEDBACK = 'awaiting_feedback',
  ERROR = 'error'
}

export type WACallStatus =
  | WACallStates.IDLE
  | WACallStates.CHECKING_LOGIN
  | WACallStates.NEEDS_TAB_SHARE
  | WACallStates.SETTING_UP
  | WACallStates.IN_PROGRESS
  | WACallStates.CONNECTED
  | WACallStates.DISCONNECTED
  | WACallStates.UPLOADING
  | WACallStates.AWAITING_FEEDBACK
  | WACallStates.ERROR;

// State shape consumed by the WhatsappCallStatus UI.
export interface WACallViewState {
  status: WACallStatus;
  error: string;
  recordingUrl: string | null;
  recordingMimeType: string | null;
  isCallCompleted: boolean;
}

export type TabSharingStatus = 'active' | 'revoked' | 'none';

export interface CrossTabCommand {
  type: 'disconnect';
  fromTabId: string;
}

export interface WAStorageState {
  status: WACallStatus;
  error: string;
  isCallCompleted: boolean;
  pendingPhone: string;
  active: boolean;
  ownerTabId: string;
  loanId: string;
  customerId: string;
  lastUpdated: number;
  tabSharingStatus: TabSharingStatus;
}

export interface WhatsappCallControls {
  state: WACallViewState;
  startCall: (phone: string) => void;
  grantTabShare: () => Promise<void>;
  disconnect: () => void;
  resetCall: () => void;
  isCallDisabled: boolean;
  isCallActiveElsewhere: boolean;
  isSameCustomerCall: boolean;
  isOwnTabCallForDifferentCustomer: boolean;
  isCallForCurrentCustomer: boolean;
}

// In-memory media handles only — call metadata (pendingPhone, loan/customer ids,
// active flag, completed recording blob) lives in Redux.
export interface MediaHandles {
  displayStream: MediaStream | null;
  micStream: MediaStream | null;
  audioCtx: AudioContext | null;
  mixedStream: MediaStream | null;
  recorder: MediaRecorder | null;
  chunks: Blob[];
  recordingBlob: Blob | null;
  sentMsgIds: Set<string>;
}

export interface FeedbackPayload {
  accountNumber: string;
  feedbacks: Feedback[];
  sourceType: string | null;
  recipientName: string;
  recipientPhoneNumber: string;
  recipientPhoneNumberCustomId: string;
  agentPhoneNumber: string;
  comments: string;
  interactionReminderDTO?: unknown;
  feedbackFormState?: FEEDBACK_FORM_STATES;
  interactionType?: ECallingType | null;
  referenceId?: string;
  interactionMetadata?: Record<string, any>;
  agentReferenceId?: string;
  callId?: string;
  metadata?: Record<string, any>;
}
